import { Component, OnInit } from '@angular/core';
import { AtomTypeDTO, AtomTypeGroupDTO } from '../../../services/api/api';
import { SelectDetailsValue } from '../../../services/gui/modal/modal.model';

@Component({
  selector: 'sb-atom-type-groups-wrapper',
  templateUrl: './sb-atom-type-groups-wrapper.component.html',
  styleUrls: ['./sb-atom-type-groups-wrapper.component.scss'],
  standalone: false,
})
export class SbAtomTypeGroupsWrapperComponent implements OnInit {
  private _atomGroups: AtomTypeGroupDTO[];

  get atomGroups(): AtomTypeGroupDTO[] {
    return this._atomGroups;
  }

  set atomGroups(atomGroups: AtomTypeGroupDTO[]) {
    this._atomGroups = atomGroups;
    let atomTypes: Map<string, AtomTypeDTO> = new Map();
    if (atomGroups) {
      for (let atomGroup of atomGroups) {
        for (let atomType of atomGroup.atomTypes) {
          atomTypes.set(atomType.id, atomType);
        }
      }
    }
    this._atomTypes = atomTypes;
  }

  _atomTypes: Map<string, AtomTypeDTO>;

  get atomTypes(): Map<string, AtomTypeDTO> {
    return this._atomTypes;
  }

  constructor() {}

  ngOnInit(): void {}

  resolveAtomGroups() {
    let values: SelectDetailsValue<any>[] = [];
    for (let group of this.atomGroups) {
      for (let type of group.atomTypes) {
        values.push({ name: type.name, value: type.id, description: type.description });
      }
    }
  }
}
